import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumericKeypadComponent } from './numeric-keypad/numeric-keypad.component';
import { ButtonComponent } from './button/button.component';
import { FrameComponent } from './frame/frame.component';
import { PinEntryComponent } from './pin-entry/pin-entry.component';
import { LabelComponent } from './label/label.component';

@NgModule({
    exports: [
        NumericKeypadComponent,
        ButtonComponent,
        FrameComponent,
        PinEntryComponent,
        LabelComponent,
    ],
    imports: [
        CommonModule
    ],
    declarations: [
        NumericKeypadComponent,
        ButtonComponent,
        FrameComponent,
        PinEntryComponent,
        LabelComponent,
    ]
})
export class InfraModule { }
